<div *ngIf="(screenSizeService.isHandset$ | async) === false; else handsetTemplate" class="horizontalNavContainer">
  <button
    mat-flat-button
    class="mr-2 horizontalNavButton"
    [routerLink]="[DefaultSubMenuItems.Registrations]"
    routerLinkActive="mat-secondary"
    (click)="onSelectionChange(DefaultSubMenuItems.Registrations)"
    data-testId="registration"
  >
    {{ StaticMessage.RegistrationsLabel | staticMessage }}
  </button>

  <button
    mat-flat-button
    class="mr-2 horizontalNavButton"
    [routerLink]="[DefaultSubMenuItems.Attachments]"
    routerLinkActive="mat-secondary"
    (click)="onSelectionChange(DefaultSubMenuItems.Attachments)"
    data-testId="attachments"
  >
    {{ StaticMessage.AttachmentsLabel | staticMessage }}
  </button>

  <button
    mat-flat-button
    class="horizontalNavButton"
    [routerLink]="[DefaultSubMenuItems.Comment]"
    routerLinkActive="mat-secondary"
    (click)="onSelectionChange(DefaultSubMenuItems.Comment)"
    data-testId="comment"
  >
    {{ StaticMessage.CommentLabel | staticMessage }}
  </button>
</div>

<router-outlet (activate)="onComponentActivated($event)"></router-outlet>

<ng-template #handsetTemplate>
  <app-navigation-select
    [items]="navigationSelectItems"
    [initialSelection]="preselectedItem"
    (selectedItemChanges)="onSelectionChange($event)"
  ></app-navigation-select>
</ng-template>
